
    <button class="back-button" type="button" (click)="back('/rec-name-result-pg')">
      Back
    </button>
    <div>
      Results can be sorted by clicking on a column header (to trigger a sort).  Multiple columns can then be sorted by holding down the shift key wile clicking on another column.
    </div>

<dx-report-viewer [reportUrl]="reportUrl" height="800px">
  <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrl"></dxrv-request-options>
          <!--<dxrv-callbacks (CustomizeMenuActions)="CustomizeMenuActions($event)" (CustomizeExportOptions)="CustomizeExportOptions($event)">
        </dxrv-callbacks>-->
</dx-report-viewer>
